import styled from 'styled-components';

const GameState = styled.div`
  color: red;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
`;

export default GameState;
